import { render } from "./IdFormularioInput.vue?vue&type=template&id=6f1349bd&scoped=true&ts=true"
import script from "./IdFormularioInput.vue?vue&type=script&lang=ts"
export * from "./IdFormularioInput.vue?vue&type=script&lang=ts"

import "./IdFormularioInput.vue?vue&type=style&index=0&id=6f1349bd&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1349bd"]])

export default __exports__